/**
 * useBreakpoint — coarse mobile | tablet | desktop bucket, matches
 * the three breakpoints in the design system tokens.
 *   mobile  : < 768px
 *   tablet  : 768–1023px
 *   desktop : >= 1024px
 *
 * SSR-safe: returns 'mobile' when window is unavailable, then updates
 * once the client mounts.
 */

import { useEffect, useState } from 'react';

const MOBILE_MAX = 767;
const TABLET_MAX = 1023;

function resolve(width) {
  if (width <= MOBILE_MAX) return 'mobile';
  if (width <= TABLET_MAX) return 'tablet';
  return 'desktop';
}

export function useBreakpoint() {
  const [bp, setBp] = useState(() => {
    if (typeof window === 'undefined') return 'mobile';
    return resolve(window.innerWidth);
  });

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const onResize = () => setBp((prev) => {
      const next = resolve(window.innerWidth);
      return next === prev ? prev : next;
    });
    window.addEventListener('resize', onResize, { passive: true });
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return bp;
}
